import { useEffect, useState } from "react";
import ApiServices from "../../config/ApiServices";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { hideLoader, showLoader } from "../../redux/actions/LoaderActions";
import Loader from "../../utils/Loader";
import { showModal } from "../../redux/actions/ModalActions";
import ModalManager from "../../Modals/ModalManager";
import { useParams } from "react-router-dom";
import moment from "moment/moment";
import * as qs from "qs";
import Pagination from "../../utils/Pagination";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import IconButton from '@mui/material/IconButton';

export default function ManageSchedule({ title }) {
    const [selectedTopics, setSelectedTopics] = useState([]);
    const dispatch = useDispatch();
    const loading = useSelector((state) => state.loader.loading);
    const isOpen = useSelector((state) => state.modal.isOpen);
    const { batchId } = useParams();
    const [schedules, setSchedules] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [totalPages, setTotalPages] = useState(0);
    const [totalData, setTotalData] = useState(0);
    const [status, setStatus] = useState(true);

    useEffect(() => {
        if (isOpen === false) {
            fetchSchedules();
        }
    }, [isOpen, currentPage, itemsPerPage, batchId, status]);

    const fetchSchedules = () => {
        dispatch(showLoader());
        ApiServices.apiRequest("getSchedule", { batchId: batchId, limit: itemsPerPage, pageno: currentPage + 1, status: status })
            .then((res) => {
                if (res.data.success) {
                    let totalData = res.data.total ? res.data.total : 0;
                    setTotalData(totalData);
                    let totalPages = Math.ceil(totalData / itemsPerPage);
                    setTotalPages(totalPages);
                    setSchedules(res.data.data);
                    console.log("schedule data is:", res.data.data)
                } else {
                    toast.error(res.data.message);
                }
            })
            .catch((err) => {
                toast.error(err?.message ? err?.message : "Something went wrong");
            })
            .finally(() => {
                dispatch(hideLoader());
            });
    };

    const handleCheckboxChange = (topicId, scheduleId) => {
        setSelectedTopics((prevSelected) => {
            if (prevSelected.includes(topicId)) {
                // If unchecked, remove from state and update API with false
                const updatedSelected = prevSelected.filter((id) => id !== topicId);
                updateTopicsStatus([topicId], scheduleId, false); 
                return updatedSelected;
            } else {
                // If checked, add to state and update API with true
                const updatedSelected = [...prevSelected, topicId];
                updateTopicsStatus([topicId], scheduleId, true); 
                return updatedSelected;
            }
        });
    };

    const updateTopicsStatus = (topics, scheduleId, isCompleted) => {
        const requestData = {
            _id: scheduleId,
            batchId: batchId,
            topicIds: JSON.stringify(topics), // single or multiple topic ids
            isCompleted: JSON.stringify(isCompleted)
        };

        ApiServices.apiRequest("updateTopicsStatus", requestData)
            .then((res) => {
                if (res.data.success) {
                    toast.success("Topics updated successfully");
                    console.log("topics after updating:",res.data.data)
                    // fetchSchedules() // optional refresh
                } else {
                    toast.error(res.data.message);
                }
            })
            .catch((err) => {
                toast.error(err?.message ? err?.message : "Something went wrong");
            });
    };

    const handleDragStart = (e, topicId) => {
        e.dataTransfer.setData("text/plain", topicId);
    };

    const handleDrop = (e, dropIndex, accordionIndex) => {
        e.preventDefault();
        const draggedTopicId = e.dataTransfer.getData("text/plain");
        const updatedSchedules = [...schedules];

        let draggedTopic;
        let fromSchedule;
        let toSchedule = updatedSchedules[accordionIndex];
        let fromScheduleId, toScheduleId;
        let fromDate, toDate, fromTopicTitle, toTopicTitle;

        updatedSchedules.forEach((schedule) => {
            const topicIndex = schedule.topics.findIndex(topic => topic._id === draggedTopicId);
            if (topicIndex !== -1) {
                [draggedTopic] = schedule.topics.splice(topicIndex, 1);
                fromDate = schedule.date;
                fromTopicTitle = schedule.title;
                fromScheduleId = schedule._id;
                fromSchedule = schedule;
            }
        });

        if (draggedTopic) {
            updatedSchedules[accordionIndex].topics.push(draggedTopic);
            toDate = updatedSchedules[accordionIndex].date;
            toTopicTitle = updatedSchedules[accordionIndex].title;
            toScheduleId = updatedSchedules[accordionIndex]._id;
        }
        setSchedules(updatedSchedules);

        const accordionElement = document.getElementById(`collapse${accordionIndex}`);
        if (accordionElement) {
            accordionElement.classList.add('show');
        }

        if (fromTopicTitle !== toTopicTitle) {
            const newHistoryEntry = {
                fromScheduleId: {
                    id: fromScheduleId,
                    title: fromTopicTitle,
                    date: fromDate
                },
                toScheduleId: {
                    id: toScheduleId,
                    title: toTopicTitle,
                    date: toDate
                },
                fromDate,
                fromTopicTitle,
                toDate,
                toTopicTitle,
                movedAt: new Date().toISOString()
            };

            draggedTopic.history = draggedTopic.history || [];
            draggedTopic.history.push(newHistoryEntry);

            const moveData = {
                batchId: batchId,
                topics: JSON.stringify([{ topictitle: draggedTopic.topictitle, topicId: draggedTopicId }]),
                fromScheduleId: fromScheduleId,
                toScheduleId: toScheduleId
            };

            ApiServices.apiRequest("moveTopic", moveData)
                .then((res) => {
                    if (res.data.success) {
                        toast.success("Topic moved successfully");
                    } else {
                        toast.error(res.data.message);
                        console.log(1, res.data.message);
                    }
                })
                .catch((err) => {
                    toast.error(err?.message ? err?.message : "Something went wrong");
                    console.log(2, err.message);
                });
        }
    };

    const getDate = (date) => {
        return moment(date).format("Do MMM YY HH:MM");
    };

    const handlePageChange = (event, newPage) => {
        setCurrentPage(newPage);
    };

    const handleItemsPerPageChange = (event) => {
        setItemsPerPage(parseInt(event.target.value, 10));
    };

    const postSchedule = (id) => {
        let data = { _id: id }
        dispatch(showModal("StatusModal", data, "postSchedule", 'post'))
    }

    const handleStatusChange = (event) => {
        setStatus(JSON.parse(event.target.value));
    };

    return (
        <>
            <div className="container">
                <div className="page-inner">
                    {loading && !isOpen ? (
                        <Loader />
                    ) : (
                        <>
                            <div className="align-items-left align-items-md-center flex-column flex-md-row pt-2 pb-4">
                                <div className="d-flex justify-content-between">
                                    <div>
                                        <h3 className="fw-bold mb-3">{title}</h3>
                                    </div>
                                    <div className="w-75 d-flex justify-content-end">
                                        <select className="form-select me-2 w-25" onChange={handleStatusChange} value={status}>
                                            <option value={true}>Active</option>
                                            <option value={false}>Removed</option>
                                        </select>
                                        <button
                                            onClick={() => {
                                                dispatch(showModal("AddSchedule"));
                                            }}
                                            className="btn btn-primary btn-round"
                                        >
                                            Add Schedule
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <hr />
                            <div className="container">
                                <div className="row">
                                    <div className="accordion" id="accordionExample">
                                        <div className="col-sm-12 text-capitalize">
                                            {schedules?.length > 0 ? (
                                                schedules?.map((el, index) => (
                                                    <div
                                                        className="accordion-item my-2"
                                                        key={index}
                                                        onDragOver={(e) => e.preventDefault()}
                                                        onDrop={(e) => handleDrop(e, 0, index)}
                                                    >
                                                        <h2 className="accordion-header">
                                                            <button
                                                                className="accordion-button align-items-center py-1 d-flex justify-content-between"
                                                                type="button"
                                                                data-bs-toggle="collapse"
                                                                data-bs-target={`#collapse${index}`}
                                                            >
                                                                {el?.title}
                                                                <div className="text-muted d-flex align-items-center fs-6">
                                                                    <span className="me-3">
                                                                        Posted By: {el?.trainerId?.name || "Unknown"}
                                                                    </span>
                                                                    {
                                                                        !el?.ishide ?
                                                                            <span>Posted {getDate(el?.PostedAt)}</span>
                                                                            :
                                                                            <a href="#" className="btn btn-primary" onClick={(e) => { e.preventDefault(); e.stopPropagation(); postSchedule(el._id) }}>Post</a>
                                                                    }
                                                                    <div className="dropdown">
                                                                        <IconButton type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                                            <MoreVertIcon />
                                                                        </IconButton>
                                                                        <ul className="dropdown-menu">
                                                                            {el?.ishide &&
                                                                                <li>
                                                                                    <a className="dropdown-item" href="#" onClick={(e) => {
                                                                                        e.preventDefault();
                                                                                        e.stopPropagation();
                                                                                        postSchedule(el._id)
                                                                                    }}>Post</a>
                                                                                </li>
                                                                            }
                                                                            <li>
                                                                                <a className="dropdown-item" href="#"
                                                                                    onClick={() => {
                                                                                        dispatch(showModal("EditSchedule", { _id: el._id }));
                                                                                    }} >Edit</a></li>
                                                                            <li>
                                                                                {status ?
                                                                                    <a className="dropdown-item" href="#" onClick={() => {
                                                                                        dispatch(showModal("StatusModal", { _id: el._id, status: false }, "changeStatusSchedule", "removeSchedule"));
                                                                                    }}>Remove</a> :
                                                                                    <a className="dropdown-item" href="#" onClick={() => {
                                                                                        dispatch(showModal("StatusModal", { _id: el._id, status: true }, "changeStatusSchedule", "addBackSchedule"));
                                                                                    }}>Add Back</a>
                                                                                }
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                </div>
                                                            </button>
                                                        </h2>
                                                        <div
                                                            id={`collapse${index}`}
                                                            className="accordion-collapse collapse"
                                                            data-bs-parent="#accordionExample"
                                                        >
                                                            <div className="accordion-body">
                                                                {el?.topics?.map((topic, topicIndex) => (
                                                                    <div
                                                                        key={topicIndex}
                                                                        draggable
                                                                        onDragStart={(e) =>
                                                                            handleDragStart(e, topic?._id)
                                                                        }
                                                                        onDragOver={(e) => e.preventDefault()}
                                                                        onDrop={(e) => handleDrop(e, topicIndex, index)}
                                                                    >
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={
                                                                                selectedTopics.includes(topic?._id) || topic.isCompleted === true
                                                                            }
                                                                            disabled={topic.isCompleted === true}
                                                                            className="form-check-input me-2"
                                                                            onChange={() => handleCheckboxChange(topic?._id, el?._id)}
                                                                        />
                                                                        {topic?.topictitle}
                                                                        <ul>
                                                                            {topic?.history?.map((entry, index) => (
                                                                                <li key={index}>
                                                                                    {`Moved from "${entry.fromScheduleId?.title}" (${getDate(entry?.fromScheduleId?.createdAt)}) to "${entry?.toScheduleId?.title}" (${getDate(entry?.toScheduleId?.createdAt)}) on ${new Date(entry.movedAt).toLocaleString()}`}
                                                                                </li>
                                                                            ))}
                                                                        </ul>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))
                                            ) : (
                                                <h1>No Schedule Present!!</h1>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className="d-flex justify-content-end">
                                    <Pagination
                                        count={totalData}
                                        page={currentPage}
                                        itemsPerPage={itemsPerPage}
                                        onPageChange={handlePageChange}
                                        onItemsPerPageChange={handleItemsPerPageChange}
                                    />
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </>
    );
}
